import { ElMessage } from 'element-plus'
import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    cities: []
  }),
  mutations: {
    SET_CITIES(state, cities) {
      state.cities = cities
    },
  },
  actions: {
    async getCities({ commit }, data) {
      try {
        const res = await apiClient('get.cities', data);
        if (res?.list) {
          commit('SET_CITIES', res.list)
        } else {
          ElMessage.error('Ошибка загрузки городов')
        }
      } catch (e) {
        ElMessage.error('Ошибка загрузки городов')
      }
    },
    async addCity({ dispatch, rootState }, payload) {
      try {
        payload.account_id = rootState.account_id
        const res = await apiClient('city.add', payload)
        if (res?.list) {
          dispatch('getCities')
          ElMessage.success('Город добавлен')
          return true
        }
        ElMessage.error(res?.error || 'Ошибка добавления города')
        return false
      } catch (e) {
        ElMessage.error('Ошибка добавления города')
        return false
      }
    },
    async updateCity({ dispatch, rootState }, payload) {
      try {
        payload.account_id = rootState.account_id
        const res = await apiClient('city.update', payload)
        if (res?.list) {
          dispatch('getCities')
          ElMessage.success('Город обновлен')
          return true
        }
        ElMessage.error(res?.error || 'Ошибка обновления города')
        return false
      } catch (e) {
        ElMessage.error('Ошибка обновления города')
        return false
      }
    },
    async deleteCity({ dispatch, rootState }, { id }) {
      try {
        const res = await apiClient('city.delete', { id, account_id: rootState.account_id })
        if (res?.list) {
          dispatch('getCities')
          ElMessage.success('Город удалён')
          return true
        }
        ElMessage.error(res?.error || 'Ошибка удаления города')
        return false
      } catch (e) {
        ElMessage.error('Ошибка удаления города')
        return false
      }
    },
    async addBranch({ commit }, data) {
      data['account_id'] = this.state.account_id
      const res = await apiClient('branch.add', data)
      if (res?.list) {
        commit('SET_CITIES', res?.list)
      }
    },
    async removeBranch({ commit }, data) {
      const res = await apiClient('branch.delete', data)
      if (res?.list) {
        commit('SET_CITIES', res?.list)
      }
    },
    async updateBranch({ commit }, data) {
      const res = await apiClient('branch.update', data)
      if (res?.list) {
        commit('SET_CITIES', res?.list)
      }
    },
    async createRoom({ commit }, data) {
      data['account_id'] = this.state.account_id
      const res = await apiClient('room.add', data)
      if (res?.list) {
        commit('SET_CITIES', res?.list)
      }
    },
    async updateRoom({ commit }, data) {
      const res = await apiClient('room.update', data)
      if (res?.list) {
        commit('SET_CITIES', res?.list)
      }
    },
    async removeRoom({ commit }, data) {
      const res = await apiClient('room.delete', data)
      if (res?.list) {
        commit('SET_CITIES', res?.list)
      }
    },
  },
  getters: {
    cities: state => state.cities
  }
}
